import React, { memo,useRef,  useState, useEffect, useLayoutEffect } from 'react';
import {  Box, styled, IconButton,CircularProgress } from '@mui/material';
import { Menu, MenuItem, Divider } from '@mui/material';

import { topBarHeight } from 'app/utils/constant';
import Icon from 'app/components/Icon';
import Api from 'app/utils/Api';


const Viewer = styled(Box)(({ theme, src, cht, me }) => ({
	top: topBarHeight,
	'& .container': { color:"#FFF", backgroundImage: `url(${src})`, height:cht-(me ? 90 : 80) },
	[theme.breakpoints.down('sm')]: { '& .container': {height:cht-(me ? 50 : 40)} },
}));

const PhotoViewer = ({ src, userId, me = false, ...props }) => {

	const ref = useRef(null);
    const [height,setHeight] = useState(0);
    const [loading,setLoading] = useState(true);
    const [photos,setPhotos] = useState([]);
    const [photo,setPhoto] = useState(null);
    const [index,setIndex] = useState(0);
    const [views,setViews] = useState({});
    const [processing,setProcessing] = useState(null);

    const [anchorEl, setAnchorEl] = useState(null);
  	const open = Boolean(anchorEl);

    useLayoutEffect(() => {
        window.addEventListener('resize', getCHeight);
        getCHeight();
        return () => {
        	window.removeEventListener('resize', getCHeight);
        	setPhotos([]);
        	setPhoto(null);
        	setLoading(true);
        	setIndex(0);
        	setProcessing(null);
        }
    },[]);

    useEffect(()=>{
    	setLoading(true);
    		
    	if( userId ){
    		Api.get(`user/photos/get/${userId}`).then(res=>{
    			setLoading(false);
    			if( res.success && (res?.data?.list || []).length > 0){
    				setPhotos(res.data.list);
    			} else{
    				setTimeout(()=>setLoading(false),10);
    				setPhotos([{id:0, image:src, datetime:null, current: true}]);
    			}
    		});
    	} else {
    		setTimeout(()=>setLoading(false),10);
    		setPhotos([{id:0, image:src, datetime:null, current: true}]);
    	}

    	return () => setLoading(true);
    },[userId]);

    useEffect(()=>{
    	if( photos.length > 0 && photos[index] ){
    		setView(photos[index]);
    		setPhoto(photos[index].image);
    	}
    },[photos,index]);

    useEffect(() => getCHeight(), []);

    const setView = (_photo) =>{
    	if( !me && _photo?.ID && !views[_photo.ID] ){
    		Api.post(`user/photos/view/${userId}/${_photo.ID}`,{}).then(()=>{
    			setViews(ps=>({...ps, [_photo.ID]:true}));
    		});
    	}
    }

    const getCHeight = () => setHeight(ref.current ? ref.current.offsetHeight : 0);

	const onClose = () => {
		if( props.onClose ) props.onClose();
	}

	const openMenu = (event) =>setAnchorEl(event.currentTarget);
  	const closeMenu = (event) =>setAnchorEl(null);
  
	const onClick = (a,d) =>{
		if( processing || !d ) return false;
		if( a === 'L')
			setIndex(index-1);
		else
			setIndex(index+1);
	}

	const onDelete = (idx,id) =>{

		if( processing ) return false;
		setProcessing('delete');
		var main = photos.length === 1;
		Api.post(`user/photos/delete/${userId}/${id}`,{main}).then(res=>{
    		setProcessing(null);
			if( res.success ){
				var _photos = [];
				photos.map((p,i)=>{
					if( i !== index )
						_photos.push(p);
					return p;
				});
				setPhotos(_photos);
				if( index >= _photos.length )
					setIndex(0);

				if( main && props.onSetMain )
					props.onSetMain({image:null});

				if( _photos.length < 1 )
					props.onClose();
			} else
				if( props.onError)
					props.onError(res.message || "Unable to process your request, try again");
		});
	}

	const setDefault = (idx,id) => {

		if( processing ) return false;
		setProcessing('setmain');

		Api.post(`user/photos/setmain/${userId}/${id}`,{}).then(res=>{
    		setProcessing(null);
			if( res.success ){
				var _photos = [];
				photos.map((p,i)=>{
					p.current = i === index ? true : false;
					_photos.push(p);
					return p;
				});
				setPhotos(_photos);
				if( props.onSetMain )
					props.onSetMain(res.data);
			} else {
				if( props.onError)
					props.onError(res.message || "Unable to process your request, try again");
			}

		});
	}

	return <Viewer className="photo_viewer" me={me ? 1 : 0} ref={ref} src={loading ?'':(photo || '')} cht={height}>
		<IconButton className="close" onClick={()=>onClose()}>
			<Icon type="r">times</Icon>
		</IconButton>
		
		<Box className={`container${photos.length > 1 ? ' mp' : ''}${me ? ' me' :''}`}>
			{photos.length > 1 && <div className="cntr">
				<span className={`lft${index > 0 ? '' :' dsb'}`} onClick={()=>onClick('L',index > 0)}><Icon>angle-left:r</Icon></span>
				<span className="cnr">{index+1}/{photos.length}</span>
				<span className={`lft${index < (photos.length-1) ? '' :' dsb'}`} onClick={()=>onClick('R',index < (photos.length-1))}><Icon>angle-right:r</Icon></span>
			</div>}
		
			{loading ? <div className="loader"><CircularProgress size={60} color="inherit" /></div>: <div className="blk" onClick={()=>{
				if( photos.length < 1 ) return false;
				var idx = index;
				idx++;
				if( idx === photos.length )
					idx = 0;
				setIndex(idx)
			}}></div>}
		</Box>
		
		{me && photos[index] && ( (photos[index].ID && !photos[index].current)) && <div className="actn">
			{processing ? <CircularProgress size={21} color="inherit" /> :
	        <IconButton
	          onClick={openMenu}
	          size="small"
	          aria-controls={open ? 'pv-menu' : undefined}
	          aria-haspopup="true"
	          aria-expanded={open ? 'true' : undefined}
	        >
		        <Icon>ellipsis-v</Icon>
		    </IconButton>}

		    <Menu
		        anchorEl={anchorEl}
		        id="pv-menu"
		        open={open}
		        onClick={()=>closeMenu()}
		        onClose={()=>closeMenu()}
		        PaperProps={{ 
		        	elevation: 2, 
		        	sx:{ backgroundColor: '#FFF',color: '#222' ,
			        	'& hr': { marginBottom:"1px !important", marginTop:"1px !important"},
	                    '& ul': { paddingTop:"2px", paddingBottom:"2px", },
	                    '& li':{ minHeight:"auto", alignItems: 'center', padding:'11px 15px', gap: '7px',lineHeight: '15px' },
		        	}
		    	}}
		        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
		        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
		      >
		      	{!photos[index].current && <>
		        <MenuItem onClick={()=>setDefault(index,photos[index].ID)}> 
		        	<Icon>camera</Icon> Make profile photo
		        </MenuItem>
		        <Divider />
		        </>}
		        <MenuItem onClick={()=>onDelete(index,photos[index].ID)}><Icon>trash</Icon> Delete</MenuItem>   
  			</Menu>
		</div>}
		
	</Viewer>;
}

export default memo(PhotoViewer);